import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { DataSource, CollectionViewer } from '@angular/cdk/collections';

import { Store } from '@src/store/store';
import { activitiesActions } from '@src/store/reducers/activitiesReducer';

type Activity = any;
const PAGE_SIZE = 15;

export class ActivityDataSource extends DataSource<Activity | undefined> {
    public loadingActivities = false;

    private fetchedPages = new Set<number>();

    private cachedData = Array.from<Activity>({ length: 1 });
    private dataStream = new BehaviorSubject<(Activity | undefined)[]>(this.cachedData);

    private subscription = new Subscription();

    constructor(
        private store: Store,
        private $filter: any,
        private projectId: number,
        private periodId: number) {
        super();
    }

    public connect(collectionViewer: CollectionViewer): Observable<(Activity | undefined)[]> {
        this.subscription.add(collectionViewer.viewChange.subscribe(async (range) => {
            const startPage = this.getPageForIndex(range.start);
            const endPage = this.getPageForIndex(range.end);
            for (let i = startPage; i <= endPage; i++) {
                await this.fetchPage(i);
            }
        }));

        return this.dataStream;
    }

    public disconnect() {
        this.subscription.unsubscribe();
    }

    public async reset(periodId: number) {
        this.periodId = periodId;
        this.cachedData = Array.from<Activity>({ length: 1 });
        this.fetchedPages = new Set<number>();
        await this.fetchPage(0);
    }

    private getPageForIndex(index: number): number {
        return Math.floor(index / PAGE_SIZE);
    }

    private async fetchPage(page: number) {
        if (this.fetchedPages.has(page)) {
            return;
        }
        this.fetchedPages.add(page);

        this.loadingActivities = true;
        await this.getActivities(page, {
            period: this.periodId,
            projectId: this.projectId,
            pageId: page + 1,
            quantity: PAGE_SIZE
        });
        this.loadingActivities = false;
    }

    private async getActivities(page: number, payload: any) {
        const activitiesData = await this.store.dispatch({ type: activitiesActions.GET_ACTIVITIES, payload });
        if (activitiesData && activitiesData.list && activitiesData.list.length > 0) {
            const activities = activitiesData.list;
            activities.forEach((item: Activity) => {
                const paramActiviyItem = item.details.split(' ');
                const paramStageName = paramActiviyItem[1];
                //check for upgrade with "__Rollback" and change it to Rollback Execution 
                let isRollbackExe1 = "";
                if(item.versionName)
                    isRollbackExe1= item.versionName.split("__")
                let isRollbackExe2: any = "";
                if(isRollbackExe1.length > 1)
                    isRollbackExe2 = isRollbackExe1[1].split("_");
                let stageName = "";
                if(isRollbackExe2.length > 0 && isRollbackExe2[0] === "Rollback")
                    stageName = "Rollback Execution"
                else
                    stageName = this.$filter('changeEnumJobNameToName')(paramStageName);
                item.message = `${stageName}`;
            });
            this.cachedData.splice(page * PAGE_SIZE, activities.length, ...activities);
            this.dataStream.next(this.cachedData);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/pipeline/activities/activity.data-source.ts